import PubSub from 'pubsub-js';

const CLEAR_SELECTION_EVENT = 'clear-selection-event';

export function emitClearSelectionEvent() {
  PubSub.publish(CLEAR_SELECTION_EVENT);
}

export function subscribeToClearSelection(cb) {
  const token = PubSub.subscribe(CLEAR_SELECTION_EVENT, cb);
  return () => {
    PubSub.unsubscribe(token);
  };
}

const INIT_SCHEDULE_LOAD_EVENT = 'init-schedule-load-event';

export function emitInitSceduleLoadEvent(data) {
  PubSub.publish(INIT_SCHEDULE_LOAD_EVENT, data);
}

export function subscribeToInitScheduleLoad(cb) {
  const token = PubSub.subscribe(INIT_SCHEDULE_LOAD_EVENT, cb);
  return () => {
    PubSub.unsubscribe(token);
  };
}

const CHANGE_SELECTION_RANGE = 'change-selection-range';

export function emitChangeSelectionEvent(data) {
  PubSub.publish(CHANGE_SELECTION_RANGE, data);
}

export function subscribeToChangeSelection(cb) {
  const token = PubSub.subscribe(CHANGE_SELECTION_RANGE, cb);
  return () => {
    PubSub.unsubscribe(token);
  };
}



// WEBPACK FOOTER //
// ./src/utils/schedule/events.js